var map = {
	"./allinc.png": 3585,
	"./allinclusive.png": 6847,
	"./alpereiser.png": 2942,
	"./amisol.png": 4541,
	"./apollo.png": 5595,
	"./escapeaway.png": 4509,
	"./lionalpin.png": 3060,
	"./loveholidays.png": 277,
	"./nazar.png": 4308,
	"./norwegianholidays.png": 6925,
	"./solfaktor.png": 3333,
	"./solia.png": 8762,
	"./soliadynamic.png": 2705,
	"./test.png": 8174,
	"./ticket.png": 5278,
	"./tripx.png": 1825,
	"./tui.png": 8404,
	"./ving.png": 8716,
	"./vingdynamic.png": 8391,
	"./vitalreiser.png": 546,
	"src/static/logo/supplier/66x22/allinc.png": 3585,
	"src/static/logo/supplier/66x22/allinclusive.png": 6847,
	"src/static/logo/supplier/66x22/alpereiser.png": 2942,
	"src/static/logo/supplier/66x22/amisol.png": 4541,
	"src/static/logo/supplier/66x22/apollo.png": 5595,
	"src/static/logo/supplier/66x22/escapeaway.png": 4509,
	"src/static/logo/supplier/66x22/lionalpin.png": 3060,
	"src/static/logo/supplier/66x22/loveholidays.png": 277,
	"src/static/logo/supplier/66x22/nazar.png": 4308,
	"src/static/logo/supplier/66x22/norwegianholidays.png": 6925,
	"src/static/logo/supplier/66x22/solfaktor.png": 3333,
	"src/static/logo/supplier/66x22/solia.png": 8762,
	"src/static/logo/supplier/66x22/soliadynamic.png": 2705,
	"src/static/logo/supplier/66x22/test.png": 8174,
	"src/static/logo/supplier/66x22/ticket.png": 5278,
	"src/static/logo/supplier/66x22/tripx.png": 1825,
	"src/static/logo/supplier/66x22/tui.png": 8404,
	"src/static/logo/supplier/66x22/ving.png": 8716,
	"src/static/logo/supplier/66x22/vingdynamic.png": 8391,
	"src/static/logo/supplier/66x22/vitalreiser.png": 546
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2596;